import { sortTableEnum } from 'enum/sortTable.enum'
import { ExternalCoursesListParams } from './GetList'
import { applyFilters } from 'helpers/filterData.helper'

export const buildQuery = (params?: ExternalCoursesListParams) => {
  const { searchText, sort, usersFilter } = {
    ...params,
  }
  const q = { s: '', g: [{}] } as any
  const { field, order } = { ...sort }
  q['s'] = (field && order && [`${field} ${sortTableEnum[order]}`]) || [
    'created_at desc',
  ]
  q['m'] = 'and'
  q['search_name_or_code_cont'] = searchText

  return { ...q, g: applyFilters(usersFilter) }
}
